import axios from 'axios'
import { postCall} from '../../utils/apiCalls'
import { BaseCoreURL } from '../../config';

import {
  OPERATOR_ROUTES_LIST,
} from './actionTypes'

import {
  PHONETIC_CITY_SEARCH,
  INVENTORY_REFRESH_URL
} from '../../config/urls';


export const fetchCities = (searchString, fieldType) => dispatch => {
  const url = BaseCoreURL + PHONETIC_CITY_SEARCH + searchString + '?is_phonetic=true';
  genericGetCall(url)
    .then(res => {
      if (res && res.status === 200) {
        dispatch({
          type: OPERATOR_ROUTES_LIST,
          payload: { data: res.data || [], fieldType },
        })
      } else {
        alert('Error, Please try again.');
      }
    })
}


export const inventoryRefresh = (query) => dispatch => {
  postCall(INVENTORY_REFRESH_URL, query)
    .then(res => {
      let isError = (res && res.response && res.response.status >= 400) || !res.data || !res.data.body || !res.data.body.length;
      if(isError) {
        alert("No routes found in DB");
        return;
      } else {
        alert("Successfully Updated")
      }
    })
}


const genericGetCall = (url, query = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  return axios
    .get(url, { headers, params: query })
    .then(response => response)
    .catch(error => {
      return error
    })
}
